import { schemes, zSchema, cardSchema, CardErrorType } from "@zeal/common";

export const getWorkerAstraCardRequestSchema = zSchema.object({
  workerID: schemes.mongoObjectId(),
  deleted: zSchema.boolean().optional(),
});

export type TGetWorkerAstraCardRequestSchema = zSchema.infer<
  typeof getWorkerAstraCardRequestSchema
>;

export const getWorkerAstraCardResponseSchema = zSchema.object({
  cards: zSchema.array(cardSchema),
  errors: zSchema
    .array(
      zSchema.object({
        type: zSchema.enum([CardErrorType.TransactionFailed]),
        card_id: schemes.uuid(),
        transaction_id: schemes.uuid(),
      })
    )
    .optional(),
});

export type TGetWorkerAstraCardResponseSchema = zSchema.infer<
  typeof getWorkerAstraCardResponseSchema
>;
